import React from "react";

const CheckBox = (props) => {
    const { item, onChange, handleCheckbox, disabled, cssClass} = props;
    return (

        <div className={`checkboxGlobal alignMiddle ${cssClass?cssClass:""} `}>
            <div className={`checkboxOutline ${item.checked && !disabled ? 'infinitycheckboxLabel' : disabled ? 'CheckBoxDisable' : ''}`} onClick={(e) => !disabled && onChange ? onChange(item, e) : handleCheckbox(item)} id={item.id}>
                {item.checked && <em className={`checkboxBackground ${disabled ? 'checkboxDisable' : 'checkboxEnable'}`}>

                    <svg className="checkboxDiv-svg" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 4L4 7L10 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </em>}
            </div>
            <label className="infinityCheckBoxLabel" onClick={() => !disabled && handleCheckbox && handleCheckbox(item)}>{item.label}</label>
            </div>
    )

}
export default CheckBox;